/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import React, { Component, createRef, forwardRef } from 'react';
import { Form, Row, Col, Button, Dropdown, FormControl } from 'react-bootstrap';
import axios from 'axios';

// project imports
import { getSellerUrl, getSellerHeaders } from 'shared/http';
import { pickupReport, salelist, reportsLocationList } from 'shared/settings/apiconfig';
import Datatable from 'shared/datatable';
import { ArrayValueReorder } from 'shared/modifiers';

// style imports
import "react-datepicker/dist/react-datepicker.css";
import './Pickup.scss';
import { NoData } from 'features/components/redirect/NoData';

/**
 * this page is used to show pickup repor in table
 * 
 * @param props
 * 
 * @return  sales list html code
 * 
**/


const CustomToggle = forwardRef(({ children, onClick }, ref) => (
    <div
        className="custom-drop-down-report"
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
        <img src={`${process.env.PUBLIC_URL}/static/media/arrow.984f931e.svg`} alt="drop-down"></img>
        {/* &#x25bc; */}
    </div>
));

export default class Pickup extends Component {
    initialSearchState;
    search;
    startDatePicker;
    endDatePicker;
    config;
    id;
    filterSearch;
    constructor(props) {
        super(props);
        /* initial search state */
        this.initialSearchState = {
            saletitle: { field: "saletitle", value: "", op: "=", join: "AND" },
            saleid: { field: "saleid", value: "", op: "=", join: "AND" },
            locationid: { field: 'locationid', value: '', op: '=', join: 'AND' },
        }
        this.state = {
            search: this.initialSearchState,
            searchData: false,
            modal: false,
            tableData: [],
            salesDetails: {},
            sales: [],
            categorylist: [],
            locations: [],
            issearch: false,
            searchInput: null,
            showSearchBox: false,
            isdisabled: false,
            location: '',
            locationlength: 0,
            Selected_salename: '',
            errorpageredirect: false,
            errorType: ''
        }
        this.config = {
            name: 'pickup report',
            url: pickupReport,
            isReport: true,
            params: {},
            columns: [
                { name: 'Item Name', property: 'itemtitle', sort: false, width: '250px', columnType: 'custom', customColumn: (row) => { if ('itemtitle' in row) return (row.itemtitle) } },
                { name: 'SKU', property: 'sku', sort: false, width: '130px' },
                { name: 'First Name', property: 'firstname', sort: false, width: '130px' },
                { name: 'Last Name', property: 'lastname', sort: false, width: '130px' },
                { name: 'Invoice Status', property: 'invoicestatus', sort: false, width: '130px' },
                { name: 'Item Receipt Method', property: 'invoiceitemreceiptmethod', sort: false, width: '150px' },
                {
                    name: '', property: 'id', columnType: 'actions', actions: [], customHeader: "CSV", width: '170px',
                }
            ],
            // sort: [],
            pagination: true,
            // field: ["city","mobilenumber","State","itemtitle","sku","invoicenumber","invoicestatus","firstname","lastname","pickuptime","signanddate","itemid"],
            filename: "pickup-report",
            csvColumn: [
                { name: 'Invoice Number', property: 'invoicenumber', },
                { name: 'Item ID', property: 'itemid', },
                { name: 'City', property: 'city', },
                { name: 'State / Province', property: 'state', },
                { name: 'Phone', property: 'mobilenumber', },
                { name: 'Item Link', property: 'itemviewurl', },
                { name: 'Item Shippable', property: 'isshippable', columnType: 'custom', customColumn: (row) => { if ('isshippable' in row && row.isshippable == '1') { return 'Yes' } else { return 'No' } } },
            ]
        };
        this.search = {};
        this.startDatePicker = false;
        this.endDatePicker = false;
        this.id = null;
        this.sales = [];
        this.filterSearch = {};
        this.dataTable = createRef();
        this.locations = [];
    }
    componentDidMount = () => {
        this.getLocationList();
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack);  
    }

    // forwardRef again here!
    // Dropdown needs access to the DOM of the Menu to measure it
    CustomMenu = React.forwardRef(
        ({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
            return (
                <div
                    ref={ref}
                    style={style}
                    className={`${className} w-100`}
                    aria-labelledby={labeledBy}
                >
                    {
                        this.state.showSearchBox ?
                            <FormControl
                                autoFocus
                                className="mx-auto my-2 w-95 border-normal"
                                placeholder="Type to filter..."
                                onChange={(e) => { this.searchSaleList(e.target.value) }}
                                value={this.state.searchInput}
                                ref={this.searchRef}
                            /> : <div className="text-center my-2">Loading...</div>
                    }
                    {
                        this.state.showSearchBox ?
                            <ul className="list-unstyled">
                                {React.Children.toArray(children).filter(
                                    (child) => child
                                )}
                            </ul> : null
                    }
                </div>
            );
        },
    );

    onBack = (e) => {
        e.preventDefault();
        window.history.pushState(null, null, window.location.pathname);
    }

    // customAddQuotes = (values) => {
    //     return values.replace(/"/g, '""')
    // }
    customItemUrl = (values) => {
        let itemurl = values["itemviewurl"];
        let hyperlink = "=HYPERLINK(\"" + itemurl + "\"\")";
        return hyperlink;
    }


    // properly convert to boolean (Standard method)
    getBool(val) {
        try {
            if (val)
                return !!JSON.parse(String(val).toLowerCase());
            else
                return false
        } catch (e) {
            return false
        }
    }
    /* called when search input changes */
    searchInputChange = (event) => {
        let eventValue = event.target.value;
        if (event.target.name === 'saleid') {
            eventValue = Number(eventValue)
        }
        if (event.target.name === 'locationid') {
            this.setState({
                ...this.state,
                issearch: true,
                isdisabled: true,
                Selected_salename: "",
                search: {
                    ...this.state.search,
                    [event.target.name]: {
                        ...this.state.search[event.target.name],
                        value: Number(eventValue)
                    }
                },
                searchData: false
            }, () => {
                this.getSaleList();
                if (event.target.value === '')
                    this.resetState();
            });
        }
        else {
            this.setState({
                ...this.state,
                issearch: true,
                search: {
                    ...this.state.search,
                    [event.target.name]: {
                        ...this.state.search[event.target.name],
                        value: eventValue
                    }
                },
                searchData: false
            }, () => {
                if (event.target.value === '')
                    this.resetState();
            });
        }
    }
    /* Get sales list */
    getSaleList = () => {
        let filter = []
        if (!this.state.search.locationid.value) {
            filter = [
                { field: 'status', value: 'Closed', op: '=', join: 'AND' },
            ];
            if (this.state.searchInput) {
                filter.push(
                    { field: 'title', value: `%${this.state.searchInput}%`, op: 'LIKE', join: 'AND' }
                );
            }
        } else {
            filter = [
                { field: 'locationid', value: this.state.search.locationid.value, op: '=', join: 'AND' },
                { field: 'status', value: 'Closed', op: '=', join: 'AND' },
            ];
            if (this.state.searchInput) {
                filter.push(
                    { field: 'title', value: `%${this.state.searchInput}%`, op: 'LIKE', join: 'AND' }
                );
            }
        }
        let field = ["title", "id"]
        var data = {
            "field": field,
            "filter": filter
        };
        axios.post(getSellerUrl(salelist), JSON.stringify(data), getSellerHeaders())
            .then(response => {
                if (response.status === 200) {
                    this.sales = response.data.data;
                    const temp = ArrayValueReorder(response.data.data, 'title');
                    this.setState({
                        ...this.state,
                        sales: temp,
                    });
                }
            })
            .catch(error => {
            });
    }
    /* called when search button clicked */
    enableSearch = () => {
        var search = {
            locationid: { ...this.state.search.locationid },
            saleid: { ...this.state.search.saleid, value: this.state.search.saleid.value },
        }
        this.setState({
            filterSearch: search,
            searchData: true
        }, () => {
            this.dataTable.current.searchData();
        });
    }

    /* called when clear in search clicked */
    resetState = () => {
        this.setState({
            ...this.state,
            search: this.initialSearchState,
            searchData: false,
            issearch: false,
            isdisabled: false,
            Selected_salename: ""
        }, () => {
            this.dataTable.current.searchData();
        });
    }
    updateTableData = (event) => {
        this.setState({
            ...this.state,
            tableData: event
        });
    }

    toggleSearchBox = (event) => {
        setTimeout(() => {
            this.setState({
                showSearchBox: event,
                sales: [],
                searchInput: null,
            });
        }, event ? 500 : 100);
    }

    searchSaleList = (value) => {
        this.setState({
            searchInput: value
        }, () => {
            this.getSaleList();
        });
    }

    saleSelect = (sale) => {
        if (this.state.search.saletitle.value !== sale.title) {
            this.setState({
                searchInput: null,
                sales: [],
                Selected_salename: sale.title
            }, () => {
                const event = {
                    "target": {
                        "name": "saleid",
                        "value": sale.id
                    }
                };
                this.searchInputChange(event);
            });
        }
    }


    /* Get Location list */
    getLocationList = async () => {
        await axios.all([
            axios.post(getSellerUrl(reportsLocationList, '' , true), JSON.stringify({ field: ['id', 'title'] }), getSellerHeaders()),
        ])
            .then(response => {
                this.locations = response[0].data.data;
                if (this.locations.length == '1') {
                    this.setState({
                        ...this.state,
                        locations: ArrayValueReorder(response[0].data.data, 'title'),
                        location: this.locations[0].title,
                        locationlength: this.locations.length,
                        isdisabled: true,
                        search: {
                            ...this.state.search,
                            locationid: {
                                ...this.state.search.locationid,
                                value: this.locations[0].id
                            },
                        }
                    }, () => {
                        this.getSaleList();
                    });
                }
                else {
                    this.setState({
                        ...this.state,
                        locations: ArrayValueReorder(response[0].data.data, 'title'),
                        location: this.locations[0].title,
                        locationlength: this.locations.length,
                    })
                }
            })
            .catch(error => {
                if(error.response?.status == 401 || error.response?.status == 404) {
                    this.setState({
                        errorpageredirect: true,
                        errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                    })
                }
            });
    }

    render() {
        if (this.state.errorpageredirect) {
            return <NoData {...this.props} type={this.state.errorType} />
        }
        return (
            <div style={{ overflow: "auto", overflowY: "overlay" }}>
                <div className="sale-search">
                    <div className="sales-list-search">
                        <Form className="sales-list-font">
                            <div className="sales-search-container">
                                <Row>
                                    <Col>
                                        <label>Location *</label>
                                        <Form.Control as="select" name="locationid" value={this.state.search.locationid.value} onKeyDown={this._handleKeyDown} onChange={(event) => this.searchInputChange(event)}>
                                            <option value="" disabled>Please select location</option>
                                            {/* {this.state.locations.length > 1 ? <option value="All">All</option> : ''} */}
                                            {this.state.locations.map((loc, index) =>
                                                <option key={index} value={loc.id}>{loc.title}</option>
                                            )}
                                        </Form.Control>
                                    </Col>
                                    <Col>
                                        <label>Sale Title</label>
                                        {/* <Form.Control as="select" name="saletitle" value={this.state.search.saletitle.value} onChange={(event) => { this.searchInputChange(event) }}>
                                            <option value="" >Select Sale</option>
                                            {this.state.sales.map((sale, index) =>
                                                <option key={index} value={sale.id}>{sale.title}</option>
                                            )}
                                        </Form.Control> */}
                                        <Dropdown onToggle={(event) => this.toggleSearchBox(event)}>
                                            <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                                                {this.state.Selected_salename ? this.state.Selected_salename : "Select Sale"}
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu as={this.CustomMenu} className="custom-dropdown-menu" >

                                                {this.state.sales.map((sale, index) => {
                                                    return (
                                                        <Dropdown.Item key={sale.id} eventKey={sale.title} onClick={() => this.saleSelect(sale)} active={this.state.search.saletitle.value === sale.title}>
                                                            {sale.title}
                                                        </Dropdown.Item>
                                                    );
                                                })}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </Col>
                                    <Col>
                                        <div className="mt-3">
                                            <Button className="clear-button" onClick={() => this.resetState()}>Clear All</Button>
                                            <Button variant="seller-search" disabled={this.state.locationlength > '1' ? !this.state.isdisabled : !this.state.isdisabled} onClick={() => this.enableSearch()}>Search</Button>
                                        </div>
                                    </Col>
                                    <Col>
                                        {/* <div className="buttonClass">
                                            <Button className="clear-button" disabled={this.state.issearch===false} onClick={() => this.resetState()}>Clear All</Button>
                                            <Button variant="search-button" disabled={this.state.issearch===false} onClick={() => this.enableSearch()}>Search</Button>
                                        </div> */}
                                    </Col>
                                    <Col></Col></Row>
                                <Row className="d-flex" style={{ marginBottom: "-1%" }}>
                                    <Col md={6}></Col>
                                    <Col md={6}>
                                        {/* <div className="buttonClass">
                                            <Button className="clear-button" disabled={this.state.issearch === false} onClick={() => this.resetState()}>Clear</Button>
                                    </div> */}
                                    </Col></Row>

                            </div>
                        </Form>

                    </div>
                </div>
                <div className="sale-list">
                    <Datatable config={{ ...this.config }} search={this.state.searchData ? { search: { ...this.state.filterSearch }, searchData: this.state.searchData } : null} ref={this.dataTable} onDataUpdate={this.updateTableData}></Datatable>
                </div>
            </div>
        );
    }
}